"use server"

import { refresh } from "next/cache"

import { errorMessage, storeApi, type ActionState } from "@/lib/api"

function selectedItems(fd: FormData) {
  return fd
    .getAll("item")
    .map(String)
    .map((id) => ({ line_item_id: id, quantity: Math.max(1, Number(fd.get(`qte_${id}`) ?? 1) || 1) }))
}

export type Receipt = { reference: string; declared_at: string; declaration: string }

// Rétractation depuis le lien de suivi.
export async function retracterDepuisSuivi(token: string, _prev: ActionState, fd: FormData): Promise<ActionState> {
  try {
    const items = selectedItems(fd)
    if (!items.length) return { error: "Sélectionnez au moins un article." }
    const receipt = await storeApi<Receipt>(`/store/suivi/${token}/retractation`, {
      body: {
        name: String(fd.get("name") ?? ""),
        email: String(fd.get("email") ?? ""),
        message: String(fd.get("message") ?? ""),
        confirmation: fd.get("confirmation") === "oui",
        items,
      },
    })
    return { ok: true, data: receipt }
  } catch (e) {
    return { error: errorMessage(e) }
  }
}

export async function envoyerDemande(token: string, _prev: ActionState, fd: FormData): Promise<ActionState> {
  try {
    const r = await storeApi<{ reference: string }>(`/store/suivi/${token}/demandes`, {
      body: {
        kind: String(fd.get("kind")),
        motif: fd.get("motif") ? String(fd.get("motif")) : undefined,
        message: String(fd.get("message") ?? ""),
        items: selectedItems(fd),
      },
    })
    refresh()
    return { ok: true, message: `Demande ${r.reference} envoyée. Un accusé de réception vous a été adressé par e-mail.` }
  } catch (e) {
    return { error: errorMessage(e) }
  }
}

// Rétractation depuis la page publique, sans compte : e-mail + numéro.
export async function rechercherCommande(_prev: ActionState, fd: FormData): Promise<ActionState> {
  const email = String(fd.get("email") ?? "").trim()
  const numero = String(fd.get("numero") ?? "").trim()
  try {
    const r = await storeApi<{ order: unknown }>("/store/retractation/recherche", { body: { email, numero } })
    return { ok: true, data: { order: r.order, email, numero } }
  } catch (e) {
    return { error: errorMessage(e) }
  }
}

export async function declarerRetractation(_prev: ActionState, fd: FormData): Promise<ActionState> {
  try {
    const items = selectedItems(fd)
    if (!items.length) return { error: "Sélectionnez au moins un article." }
    const receipt = await storeApi<Receipt>("/store/retractation/declarer", {
      body: {
        email: String(fd.get("email") ?? ""),
        numero: String(fd.get("numero") ?? ""),
        name: String(fd.get("name") ?? ""),
        message: String(fd.get("message") ?? ""),
        confirmation: fd.get("confirmation") === "oui",
        items,
      },
    })
    return { ok: true, data: receipt }
  } catch (e) {
    return { error: errorMessage(e) }
  }
}
